import { baseApi } from "../apiMananger";

export const kpiApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getKPI: build.query({
      query: ({ filter, month_name, year, start_date, end_date } = {}) => {
        const params = new URLSearchParams();
        if (filter) params.append('filter', filter);
        if (month_name) params.append('month_name', month_name);
        if (year) params.append('year', year);
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        
        const queryString = params.toString();
        return queryString ? `kpi/?${queryString}` : 'kpi/';
      },
      providesTags: ["Kpi"],
    }),
  }),
});

export const { useGetKPIQuery } = kpiApi;
